var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{staticStyle:{"width":"850px","position":"absolute","top":"40%","left":"0","right":"0","margin":"auto"}},[_c('el-alert',{attrs:{"type":"icon","description":"已核销","show-icon":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }